<ng-template #head></ng-template>
<ng-template #notFound></ng-template>
<ng-template #foot></ng-template>
